import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';

const DEFAULT_AUTOMATED_RULES_TOP = '20';

interface IFetchTaskItemsUrlProps {
  customerId: string;
  accountId: string;
  queries?: any;
}

const DefaultAutomatedRulesQueries = {
  $filter: 'Type eq Enum.TaskItemType\'AdvertiserSearch\'',
  $top: DEFAULT_AUTOMATED_RULES_TOP,
  $count: 'true',
};

interface IFetchTaskItemsProps extends IFetchTaskItemsUrlProps {
  ccToken: string;
}

function getTaskItemsUrl({
  customerId,
  accountId,
  queries = DefaultAutomatedRulesQueries,
}: IFetchTaskItemsUrlProps) {
  const queryString = new URLSearchParams(queries);

  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/TaskItems?${queryString}`;
}

export function fetchTaskItems({
  accountId,
  customerId,
  ccToken,
}: IFetchTaskItemsProps) {
  const url = getTaskItemsUrl({ customerId, accountId });

  return axios.get(
    url,
    {
      headers: {
        Authorization: ccToken,
        'content-type': 'application/json',
      },
      withCredentials: true,
    } as AxiosRequestConfig,
  );
}
